import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  "class": "w-1200px",
  style: {
    "margin": "0 auto"
  }
};
import indexProjectItemRight from './indexProjectItemRight.vue';
import indexProjectItemLeft from './indexProjectItemLeft.vue';
import indexProjectSpecial from './indexProjectSpecial.vue';
var url = 'https://qinghuiche.oss-cn-beijing.aliyuncs.com/officialWebsite/';
export default {
  __name: 'indexProjectShow',
  emits: ['handleClick'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var list = [{
      title: '智能工单系统',
      subtitle: '全流程可配置工单管理，支持多渠道接入',
      layout: 'right',
      introduction: ['电话、微信小程序、App多渠道接入工单', '完整的工单生命周期管理，从创建到归档全程可追溯', '强大的工单检索功能，支持自定义导出和质检'],
      img: [url + 'aiordersystem.png']
    }, {
      title: '智能助手',
      subtitle: '实时通话转译与智能填单，辅助话务员提高效率与准确性',
      layout: 'left',
      introduction: ['实时通话内容转文字转录，AI智能识别自动填单', '知识库实时推荐匹配，历史工单智能提醒辅助决策', '地图定位精准服务，同诉工单智能识别'],
      img: [url + 'aiassistant.png']
    }, {
      title: '智能派单',
      subtitle: '基于自研算法的智能派单建议，优化资源分配，提升派单准确率',
      layout: 'right',
      introduction: ['多维度智能派单算法，实现最优资源配置', '辅助话务员快速派单，大幅提升工单分配效率', '智能分配工单资源，优化人力资源配置'],
      img: [url + 'aitask.png']
    }, {
      title: '智能知识库',
      subtitle: '全生命周期知识管理，智能解析生成知识，助力精准服务应答',
      layout: 'left',
      introduction: ['智能语义检索知识，支持多种格式知识导出', '文件智能解析处理，批虽自动生成知识条目', '全生命周期管理，支持创建审核分类'],
      img: [url + 'aiknowledge2.png', url + 'aiknowledge.png']
    }, {
      title: '培训考试系统',
      subtitle: '完整的在线培训考核体系，包含入职打字考试等专业化工具',
      layout: 'right',
      introduction: ['智能题库考试管理，专业打字速度技能测试', '在线课程体系管理，实时跟踪学员学习进度', '在线课程体系管理，实时跟踪学员学习进度'],
      img: [url + 'examb.png', url + 'examt.png']
    }, {
      title: '智能网格系统',
      subtitle: '可视化网格管理，精准划分服务区域，优化网格员工作分配',
      layout: 'left',
      introduction: ['地图可视化网格划分，灵活配置管理区域范围', '网格员分类精细管理，移动端接单培训一体化', '多网格跨区管理，按事件类型智能分配'],
      img: [url + 'gridsystem.png']
    }, {
      title: '智能统计报告',
      subtitle: '多维度数据统计分析，自动生成日报专报，数据驱动决策',
      layout: 'right',
      introduction: ['网多维度数据统计分析，支持定制统计规则配置', '预制多种报告模板，自动生成日报专报分析', '全面运营数据统计，支持话务工单人员分析'],
      img: [url + 'aireport.png']
    }, {
      title: '智能数据大屏',
      subtitle: '可视化数据总览，实时运营监管，支持智能问数交互',
      layout: 'sepcial',
      introduction: ['运营数据实时可视化监控，全方位数据总览展示', '专题深度分析功能，智能问答交互数据查询', '绩效治理可视化，智能问数辅助决策'],
      img: [url + 'bigscreen.png']
    }, {
      title: 'Ai政务智能体',
      subtitle: '基于大语言模型的智能政务助手，提升服务效率与用户体验',
      layout: 'right',
      introduction: ['实时解答政务咨询，精准理解用户意图，提供个性化服务', '支持上下文语义理解，实现自然流畅的连续对话体验', '基于向量数据库快速匹配政策文件，提供精准答案溯源'],
      img: [url + 'aigovern.png']
    }];
    var emit = __emit;
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("main", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, function (item, i) {
        return _createElementVNode("div", {
          key: i,
          "class": "w-100%"
        }, [item.layout === 'right' ? (_openBlock(), _createBlock(indexProjectItemRight, {
          key: 0,
          num: i + 1,
          item: item,
          onHandleClick: _cache[0] || (_cache[0] = function ($event) {
            return emit('handleClick', $event);
          })
        }, null, 8, ["num", "item"])) : item.layout === 'left' ? (_openBlock(), _createBlock(indexProjectItemLeft, {
          key: 1,
          num: i + 1,
          item: item,
          onHandleClick: _cache[1] || (_cache[1] = function ($event) {
            return emit('handleClick', $event);
          })
        }, null, 8, ["num", "item"])) : (_openBlock(), _createBlock(indexProjectSpecial, {
          key: 2,
          onHandleClick: _cache[2] || (_cache[2] = function ($event) {
            return emit('handleClick', $event);
          }),
          num: i + 1,
          item: item
        }, null, 8, ["num", "item"]))]);
      }), 64))]);
    };
  }
};